// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3EcArZWtvzftnjWuKP-xaE{counter-increment:step-counter}._3EcArZWtvzftnjWuKP-xaE:not(:last-child){border-bottom:1px solid #f4f4f4}._1IDvIJS9N2NwY6DAQG3qRU{max-width:17.9rem}._1IDvIJS9N2NwY6DAQG3qRU:before{content:counter(step-counter) \". \";display:inline;font-weight:700}@media (min-width:992px){._3EcArZWtvzftnjWuKP-xaE:not(:last-child){border:none;border-right:1px solid #f4f4f4}._1IDvIJS9N2NwY6DAQG3qRU{max-width:18.1rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepContainer": "_3EcArZWtvzftnjWuKP-xaE",
	"step": "_1IDvIJS9N2NwY6DAQG3qRU"
};
module.exports = ___CSS_LOADER_EXPORT___;
